<template>
  <div class="container is-fullhd">
    <section class="section">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">
          <h1 class="title">Login to your account</h1>
          <p class="subtitle"><a @click="goToSignUp">Don't have an account? Sign Up!</a></p>
          <form @submit.prevent="userSignIn" novalidate>
            <error-message/>
            <b-field label="Email">
              <b-input v-model="email" required></b-input>
            </b-field>
            <b-field label="Password">
              <b-input type="password"
                  v-model="password"
                  required>
              </b-input>
            </b-field>
            <button type="submit" v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-primary">
              Sign in
            </button>
          </form>

          <hr>
          <p class="subtitle"><a @click="showForgotPassword">Forgot your password?</a></p>
          <form @submit.prevent="sendPasswordResetEmail" v-if="showForgotPasswordSection" novalidate>
            <b-field label="Please enter your email" :message="getEmailResetMessage" :type="getEmailResetType">
              <b-input v-model="emailReset" required @input="$v.emailReset.$touch()"></b-input>
            </b-field>
            <button type="submit" class="button is-primary">
              Send
            </button>
          </form>
          <hr>
          <div id="firebaseui-auth-container"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import errorMessage from '@/components/error-message'
import firebaseService from '@/services/firebase.service'
import { email } from 'vuelidate/lib/validators'

export default {
  name: 'Signin',
  data () {
    return {
      email: '',
      emailReset: '',
      password: '',
      showForgotPasswordSection: false
    }
  },
  mounted () {
    firebaseService.getAuthenticationForm('#firebaseui-auth-container')
  },
  methods: {
    goToSignUp () {
      this.$router.push('/signup')
    },
    async sendPasswordResetEmail () {
      if (this.emailReset && !this.$v.$invalid) {
        try {
          await firebaseService.sendPasswordResetEmail(this.emailReset)
          this.$toast.open({
            message: 'You\'ll receive a password reset email shortly!',
            type: 'is-success'
          })
          this.showForgotPasswordSection = false
        } catch (err) {
          this.$toast.open({
            message: 'An error happen, please try again',
            type: 'is-danger'
          })
        }
      }
    },
    showForgotPassword () {
      this.showForgotPasswordSection = true
    },
    userSignIn () {
      this.$store.dispatch('userSignIn', {
        email: this.email,
        password: this.password
      })
    }
  },
  computed: {
    getEmailResetMessage () {
      if (this.$v.emailReset.$dirty && !this.$v.emailReset.email) {
        return 'Please enter a valid email'
      }
      return ''
    },
    getEmailResetType () {
      if (this.$v.emailReset.$dirty && this.$v.emailReset.$invalid) {
        return 'is-danger'
      }
      return ''
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'signin' && localLoading.active
    }
  },
  components: {
    errorMessage
  },
  validations: {
    emailReset: {
      email
    }
  }
}
</script>

<style>
  @import "../../node_modules/firebaseui/dist/firebaseui.css";
</style>
